<ng-container>
  <div class="row row--valign-center row-gap--none row--space-between top-nav my--sm">
    <div class="top-nav-buttons row column-lg--7 column-md--12 row--valign-center row-gap--none mt--xs mt--lg-none">
      @if (!isAdminModule) {
      <div class="row row--valign-center row--nowrap row-gap--none">
        <span class="icon-pin bold text-small lineheight--none mr--xs color--blue-grey"></span>
        @if(isAdminRole){
        <mat-select
          class="mr--sm"
          [(ngModel)]="currentLocation"
          (selectionChange)="changeLocationSelector($event.value)"
        >
          <mat-option disabled>
            <ngx-mat-select-search
              [formControl]="locationFilterCtrl"
              placeholderLabel="{{ 'App.Common.Placeholders.SearchLocation' | translate }}"
            ></ngx-mat-select-search>
          </mat-option>
          <!-- Keep current selection visible when filtered out -->
          <mat-option *ngIf="selectedLocation && !isSelectedInFiltered()" [value]="currentLocation">
            {{ selectedLocation.addressLine2 }} - {{ selectedLocation.locationName }}
          </mat-option>
          <!-- Show filtered results -->
          @for (location of filteredLocations; track location.id) {
          <mat-option [value]="location.id">{{ location.addressLine2 }} - {{ location.locationName }}</mat-option>
          }
          <!-- No results indicator -->
          <mat-option disabled *ngIf="filteredLocations && filteredLocations.length === 0">
            {{ 'App.Common.Labels.NoResults' | translate }}
          </mat-option>
        </mat-select>
        } @else{
        <span disable class="column--auto column-md--10 column-lg--10 text-small bold lineheight--none color--blue-grey mr--xs">{{ this.locationName }}</span>
        }
      </div>
      }
      <div class="row column-lg--2 column-sm--4 row--flex-end row-gap--none row--nowrap">
        <button mat-button (click)="toggleLanguage()" *ngIf="!isMobile">
          <span class="text-small bold lineheight--none color--blue-grey">{{
            translate.currentLang == 'en' ? 'FR' : 'EN'
          }}</span>
        </button>
        <button mat-button (click)="showAccountDetail()" *ngIf="!isMobile">
          <mat-icon class="material-symbols-outlined profile-button color--navy mr--none">account_circle</mat-icon>
        </button>
        <!-- Mobile Navigation Button -->
        <button
          *ngIf="isMobile"
          mat-icon-button
          (click)="onToggleMobileNav()"
          aria-label="Open mobile navigation">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </div>
    <div class="column-lg--5 column-md--12">
      <h2 [ngClass]="{ 'mb--xs': pageTitle === 'pickupconfirmation' }" class="my--xs mt--lg-none">
        {{ 'App.PageTitles.' + pageTitle | translate }}
      </h2>
      <div
        *ngIf="pageTitle === 'pickupconfirmation'"
        class="display-inline-flex mb--md row row-gap--none row--valign-center"
      >
        <a class="text-decoration-none color--electric-blue" routerLink="/deliver">{{
          'App.PageTitles.deliver' | translate
        }}</a>
        <span class="icon-chevron-right"></span>
        <span> {{ 'App.PageTitles.pickupconfirmation' | translate }} </span>
      </div>
    </div>
  </div>
</ng-container>
